// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__22wja","title":"Header_title__1qhXY","side":"Header_side__2KV-l"};